export const field = (label, sources, options = {}) => ({
  label,
  sources,
  ...options,
});
